module.exports = __webpack_public_path__ + "static/img/volunteerlist.db1ccf50.png";